import { render, staticRenderFns } from "./EcosystemsSharing.vue?vue&type=template&id=00645c29&scoped=true&"
import script from "./EcosystemsSharing.vue?vue&type=script&setup=true&lang=js&"
export * from "./EcosystemsSharing.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00645c29",
  null
  
)

export default component.exports